<script setup lang="ts">
import { computed } from 'vue'

import { Moon, Sun } from '@lucide/vue'
import { useColorMode } from '@vueuse/core'

import { Button } from '#ui/button'

const mode = useColorMode({ storageKey: 'admin.theme', initialValue: 'light' })

const isDark = computed(() => mode.value === 'dark')
const label = computed(() => (isDark.value ? 'Light mode' : 'Dark mode'))
</script>

<template>
  <Button
    variant="ghost"
    size="icon"
    :aria-label="label"
    :title="label"
    @click="mode = isDark ? 'light' : 'dark'"
  >
    <Sun v-if="isDark" />
    <Moon v-else />
  </Button>
</template>
